import actions from 'redux/actions'
import { constants, mixpanel } from 'common/helpers'

import syncUserAndSubscription from './syncUserAndSubscription'


let _applePaySession


const setupBeginApplePay = ({ begin, tokenName, sessionName }) => async (values) => {
  const { paymentType, applePayValidationURL, ...rest } = values

  mixpanel.track(constants.analyticsEvents.tech.beginApplePay)

  let token = actions.models.requestTokens.get(tokenName)

  if (!token) {
    const tokens  = await actions.models.requestTokens.fetch()
    token         = tokens[tokenName]
  }

  const body = {
    token,
    paymentType,
    applePayValidationURL,
    ...rest,
  }

  return begin(body)
    .then(
      ({ applePaySession, [sessionName]: session }) => {
        _applePaySession = session
        return applePaySession
      },
      (err) => Promise.reject(err)
    )
}

const setupCommitApplePay = (values) => {
  const { commit, session, paymentType, sessionName, tokenName } = values

  return (values) => {
    const body = {
      ...values,
      token: actions.models.requestTokens.get(tokenName),
      [sessionName]: _applePaySession,
    }

    mixpanel.track(constants.analyticsEvents.tech.commitApplePay)

    return commit(body)
      .then(
        (result) => {
          if (session && session.completePayment) {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
          }

          return syncUserAndSubscription({ paymentType, ...result, facebookEvent: 'applePay' })
        },
        (err) => {
          if (session && session.completePayment) {
            session.completePayment(window.ApplePaySession.STATUS_FAILURE)
          }

          return Promise.reject(err)
        }
      )
  }
}


export {
  setupBeginApplePay,
  setupCommitApplePay,
}
